import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';

/**
 * Initializes Select2 on the provided selector.
 * @param {string|jQuery} selector
 * @param args
 */
export const initSelects = (selector = 'select', args = {}) => {
    const $elements = $(selector);

    if (!$elements.length) return;

    $elements.each(function (index, element) {
        const $el = $(element);

        // Prevent double initialization
        if ($el.hasClass('select2-hidden-accessible')) return;

        const defaults = {
            placeholder: $el.data('placeholder') || selectrum.select_placeholder,
            width: '100%', // Often needed for responsive layouts
            minimumResultsForSearch: Infinity,
        };

        args = {...defaults, ...args};

        $el.select2(args);
    });
};

// You can also export a default auto-init function
export default function init() {
    initSelects('.listing select');
    initSelects('.eventsListing select');
}